// Module
var code = `<div class="svc-page-navigator-item-content" data-bind="click: action, key2click, css: { 'svc-page-navigator-item--selected': active, 'svc-page-navigator-item--disabled': disabled }">
  <div class="svc-page-navigator-item__dot" data-bind="attr: { title: text }">
    <div class="svc-page-navigator-item__dot-content"></div>
  </div>

  <div class="svc-page-navigator-item__banner">
    <span class="svc-page-navigator-item__text" data-bind="text: text"></span>
    <span class="svc-page-navigator-item__dot"><span class="svc-page-navigator-item__dot-content"></span></span>
  </div>
</div>`;
// Exports
export default code;